import { render, staticRenderFns } from "./agreement.vue?vue&type=template&id=11ac9e7c&"
var script = {}
import style0 from "./agreement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports